import React, { forwardRef, memo } from "react";
import { View, type ViewStyle } from "react-native";
import ActionSheet from "react-native-actions-sheet";
import type { ActionSheetProps, ActionSheetRef } from "react-native-actions-sheet";
import { AppText } from "@/components/ui/AppText";
import { useI18n } from "@/context/I18nContext";
import type { TranslationKeys } from "@chinese-vendor/i18n";

export interface AppActionSheetProps extends Omit<ActionSheetProps, "children"> {
  children: React.ReactNode;
  headerTitle?: TranslationKeys;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: () => void;
}

export const AppActionSheet = memo(
  forwardRef<ActionSheetRef, AppActionSheetProps>(function AppActionSheet(
    {
      children,
      headerTitle,
      header,
      footer,
      containerStyle,
      defaultOverlayOpacity = 0.4,
      onClose,
      ...rest
    },
    ref
  ) {
    const { t } = useI18n();
    const mergedContainerStyle: ViewStyle[] = [
      { borderTopLeftRadius: 16, borderTopRightRadius: 16 },
      containerStyle as ViewStyle,
    ];

    return (
      <ActionSheet
        ref={ref}
        gestureEnabled
        defaultOverlayOpacity={defaultOverlayOpacity}
        containerStyle={mergedContainerStyle}
        onClose={onClose}
        {...rest}
      >
        {header != null ? (
          header
        ) : headerTitle != null ? (
          <View className="px-4 pt-4 pb-2">
            <AppText weight="semibold" className="text-base text-dark-text-50 text-center">
              {t(headerTitle)}
            </AppText>
          </View>
        ) : null}

        {children}

        {footer != null ? footer : null}
      </ActionSheet>
    );
  })
);
